const local = {
    instruction: "升级你的城堡",
    races : ["人类", "精灵", "兽人", "地精", "亡灵"],
    scale : ["小型城堡", "中型城堡", "大型城堡"],
    serialNumber: "序列号",
    specialid: "特殊标识",
    race: "种族",
    economic: "经济",
    military: "军事",
    cards: ["城堡大小", "城堡样式", "城堡颜色", "徽标样式", "徽标颜色", "徽标位置", "种族", "特殊标识"],
    hint: "提示",
    hintDetail: "10秒内你只能吞并一块土地。如果你想更换城堡的样式，可以返回第1课第1章重新编辑你的城堡。",
    castleInformation: "城堡信息",
    castleLevel: "城堡等级",
    castleEconomy: "经济实力",
    annexLand: "吞并土地",
    annexPrefix: "请等待 ",
    annexSuffix: " 秒后继续",
    random: "系统随机产生土地：类型 ",
    annex: "吞并成功，经济实力增加到 ",
    levelup: "恭喜升级！现在你的城堡等级为 ",
};

export {local};